import * as React from "react";

import {
    Edit,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
   
} from "react-admin";




const validateUserUpdate = (values) => {
    const errors = {};
    if (values.password !== values.confirmPassword) {
        errors.password = "Passwords do not match";
        errors.confirmPassword = "Passwords do not match";
    }

    return errors;
};

const CategoryTitle = ({ record }) => {
    return <span>Post {record ? `"${record.category_name}"` : ""}</span>;
};


export const CategoryEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Changes saved`);
        redirect("/categories");
        refresh();
    };

    const onFailure = (error) => {
        notify(`Could not edit Category: ${error.message}`);
        refresh();
    };
    return (
        <Edit
            bulkActionButtons={false}
            title={<CategoryTitle />}
            mutationMode="pessimistic"
            undoable={false}
            onSuccess={onSuccess}
            onFailure={onFailure}
            {...props}
        >
            <SimpleForm validate={validateUserUpdate}>
                <>
                    <div className="category_feild">
                        <h2>Edit Category</h2>
                        <TextInput fullWidth={true} label="category_name" source="category_name" />
                    </div>
                </>
            </SimpleForm>
        </Edit>
    );
};
